/* NOT 25 HOURS — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.n25-reveal:not(.n25-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('n25-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('n25-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: lo que ya está en pantalla aparece siempre, aunque el observer falle
    function sweep() {
      var limit = window.innerHeight * 0.95;
      (root || document).querySelectorAll('.n25-reveal:not(.n25-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < limit && r.bottom > 0) { el.classList.add('n25-visible'); io.unobserve(el); }
      });
    }
    requestAnimationFrame(sweep);
    setTimeout(sweep, 1200);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 250);
    }, { passive: true });
  }

  function initCountUp(root) {
    var els = (root || document).querySelectorAll('[data-n25-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-n25-count'));
      var decimals = (el.getAttribute('data-n25-count').split('.')[1] || '').length;
      if (reduce || isNaN(target)) { el.textContent = el.getAttribute('data-n25-count'); return; }
      var start = null, dur = 1600;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Texto que se "enciende" palabra a palabra al hacer scroll */
  var statements = [];
  function initStatements(root) {
    (root || document).querySelectorAll('[data-n25-statement]').forEach(function (el) {
      if (el.dataset.n25Ready) return;
      el.dataset.n25Ready = '1';
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function (w) { return '<span class="n25-w">' + w.replace(/</g, '&lt;') + '</span>'; }).join(' ');
      statements.push(el);
    });
  }
  function updateStatements() {
    var vh = window.innerHeight;
    statements.forEach(function (el) {
      var words = el.querySelectorAll('.n25-w');
      if (reduce || document.documentElement.classList.contains('shopify-design-mode')) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
      var r = el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    });
  }

  /* Parallax suave */
  var parallax = [];
  function initParallax(root) {
    (root || document).querySelectorAll('[data-n25-parallax]').forEach(function (el) {
      if (parallax.indexOf(el) === -1) parallax.push(el);
    });
  }
  function updateParallax() {
    if (reduce) return;
    var vh = window.innerHeight;
    parallax.forEach(function (el) {
      var k = parseFloat(el.getAttribute('data-n25-parallax')) || 0;
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var center = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (center * k * -100).toFixed(1) + 'px,0) scale(1.08)';
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { updateStatements(); updateParallax(); ticking = false; });
  }

  /* ---------- Página de producto ---------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '€{{amount}}';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, dot);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-n25-pdp]').forEach(function (pdp) {
      if (pdp.dataset.n25Ready) return;
      pdp.dataset.n25Ready = '1';
      var dataEl = pdp.querySelector('[data-n25-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = pdp.getAttribute('data-money-format');
      var track = pdp.querySelector('.n25-pdp__track');
      var slides = track ? track.querySelectorAll('.n25-pdp__slide') : [];
      var thumbs = pdp.querySelectorAll('.n25-pdp__thumb');
      var dots = pdp.querySelectorAll('.n25-pdp__dots span');
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var addBtn = pdp.querySelector('.n25-pdp__add');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var errorEl = pdp.querySelector('.n25-pdp__error');
      var selected = [];
      pdp.querySelectorAll('[data-n25-option]').forEach(function (group, i) {
        var active = group.querySelector('.is-active');
        selected[i] = active ? active.getAttribute('data-value') : null;
      });

      // ---- Packs ----
      var offersEl = pdp.querySelector('[data-n25-offers]');
      var offers = offersEl ? offersEl.querySelectorAll('[data-n25-offer]') : [];
      function selectOffer(o) {
        if (o.hasAttribute('data-soldout')) return;
        offers.forEach(function (x) { x.classList.toggle('is-active', x === o); x.setAttribute('aria-checked', x === o ? 'true' : 'false'); });
      }
      function activeOffer() { return offersEl ? offersEl.querySelector('[data-n25-offer].is-active') : null; }
      offers.forEach(function (o) {
        o.addEventListener('click', function (e) { if (e.target.closest('select')) return; selectOffer(o); });
        o.addEventListener('keydown', function (e) { if (e.target.closest('select')) return; if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectOffer(o); } });
      });
      if (offersEl) {
        var wanted = new URLSearchParams(window.location.search).get('bundle');
        if (wanted) { var m = offersEl.querySelector('[data-n25-offer][data-qty="' + wanted + '"]'); if (m) selectOffer(m); }
        offersEl.querySelectorAll('select').forEach(function (sel) {
          sel.addEventListener('change', function () {
            var opt = sel.selectedOptions[0];
            var img = sel.closest('.n25-offer__row').querySelector('[data-n25-thumb]');
            if (img && opt && opt.dataset.img) img.src = opt.dataset.img;
          });
        });
      }

      function goTo(index, smooth) {
        if (!track || !slides[index]) return;
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        setActive(index);
      }
      function setActive(index) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      if (track) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(i);
        }, { passive: true });
      }

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; });
        });
      }

      function update(v) {
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addLabel.textContent = addBtn.getAttribute('data-unavailable'); }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (offersEl) {
          offers.forEach(function (o) {
            var first = o.querySelector('[data-n25-unit]');
            if (first) { first.value = v.id; first.dispatchEvent(new Event('change')); }
          });
        }
        var price = pdp.querySelector('[data-n25-price]');
        var compare = pdp.querySelector('[data-n25-compare]');
        var badge = pdp.querySelector('[data-n25-badge]');
        if (price) price.textContent = money(v.price, fmt);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compare) { compare.textContent = onSale ? money(v.compare_at_price, fmt) : ''; compare.hidden = !onSale; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = badge.getAttribute('data-template').replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100));
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addLabel.textContent = v.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-soldout');
        }
        if (v.featured_media) {
          var idx = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
          if (idx > -1) goTo(idx);
        }
        if (window.history && window.history.replaceState && pdp.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      pdp.querySelectorAll('[data-n25-option]').forEach(function (group, i) {
        var label = group.querySelector('[data-n25-option-value]');
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
            selected[i] = btn.getAttribute('data-value');
            if (label) label.textContent = btn.getAttribute('data-value');
            update(findVariant());
          });
        });
      });

      // Cantidad
      var qty = pdp.querySelector('.n25-qty input');
      pdp.querySelectorAll('.n25-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          var max = parseInt(qty.getAttribute('max'), 10) || Infinity;
          qty.value = Math.min(max, Math.max(1, n + parseInt(b.getAttribute('data-step'), 10)));
        });
      });

      // Mostrar la foto de la variante seleccionada al cargar
      var initial = findVariant();
      if (initial && initial.featured_media) {
        var i0 = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media-id') == initial.featured_media.id; });
        if (i0 > 0) requestAnimationFrame(function () { goTo(i0, false); });
      }

      // Añadir al carrito abriendo el carrito lateral de Dawn
      if (form) {
        form.addEventListener('submit', function (e) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var hasCart = cart && typeof cart.renderContents === 'function';
          var offer = activeOffer();
          if (!hasCart && !offer) return; // envío normal
          e.preventDefault();
          if (errorEl) errorEl.hidden = true;
          addBtn.classList.add('is-loading');
          var sections = hasCart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
          var body, headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' };
          if (offer) {
            var items = [];
            var units = offer.querySelectorAll('[data-n25-unit]');
            if (units.length) {
              var counts = {}, order = [];
              units.forEach(function (u) { if (!counts[u.value]) { counts[u.value] = 0; order.push(u.value); } counts[u.value]++; });
              order.forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
            } else {
              items.push({ id: parseInt(idInput.value, 10), quantity: parseInt(offer.getAttribute('data-qty'), 10) || 1 });
            }
            offer.querySelectorAll('[data-n25-gift]').forEach(function (g) {
              if (g.value) items.push({ id: parseInt(g.value, 10), quantity: 1, properties: { Gift: pdp.getAttribute('data-gift-note') || 'Free with your bundle' } });
            });
            var payload = { items: items };
            if (hasCart) { payload.sections = sections.join(','); payload.sections_url = window.location.pathname; }
            body = JSON.stringify(payload);
            headers['Content-Type'] = 'application/json';
          } else {
            body = new FormData(form);
            body.append('sections', sections.join(','));
            body.append('sections_url', window.location.pathname);
          }
          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST', headers: headers, body: body
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
                return;
              }
              if (!hasCart) { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents(res);
              enforceSingle();
            })
            .catch(function () { form.submit(); })
            .finally(function () { addBtn.classList.remove('is-loading'); });
        });
      }
    });
  }

  /* ---------- Regalos de los packs: nunca más de los que tocan ---------- */
  var enforcing = false;
  function enforceGifts() {
    var rules = window.n25GiftRules;
    if (!rules || enforcing) return;
    var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var watches = 0;
      cart.items.forEach(function (i) { if (i.product_id === rules.watchProductId) watches += i.quantity; });
      var updates = {}, changed = false;
      rules.gifts.forEach(function (g) {
        var allowed = watches >= g.minWatches ? 1 : 0;
        cart.items.forEach(function (i) {
          if (i.product_id !== g.productId) return;
          var keep = Math.min(i.quantity, allowed);
          allowed -= keep;
          if (keep !== i.quantity) { updates[i.key] = keep; changed = true; }
        });
      });
      if (!changed) return;
      enforcing = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { updates: updates };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
      }
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
          if (drawer && res.sections) {
            drawer.getSectionsToRender().forEach(function (sec) {
              var el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
              if (!el || !res.sections[sec.id]) return;
              el.innerHTML = drawer.getSectionInnerHTML(res.sections[sec.id], sec.selector);
            });
            if (res.item_count === 0) drawer.classList.add('is-empty');
          }
        })
        .finally(function () { enforcing = false; });
    });
  }


  /* ---------- Packs en otras monedas ----------
     El descuento de cada pack es una cantidad fija en euros que Shopify convierte con su tipo de cambio.
     Aquí calculamos el mismo precio que verá el cliente en el carrito. */
  function fmtLocal(cents) {
    var cur = window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function localizeBundles(root) {
    var rate = window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) : 1;
    if (!rate || rate === 1) return;
    (root || document).querySelectorAll('[data-n25-localize]').forEach(function (el) {
      var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
      var regular = parseInt(el.getAttribute('data-regular'), 10);
      var bundle = parseFloat(el.getAttribute('data-shop-bundle'));
      var ref = parseFloat(el.getAttribute('data-shop-ref'));
      if (!regular || !bundle || !ref) return;
      var off = Math.round((ref * qty - bundle) * 100 * rate);
      var price = regular - Math.max(0, off);
      el.setAttribute('data-bundle', price);
      el.querySelectorAll('[data-n25-out]').forEach(function (o) { o.textContent = fmtLocal(price); });
      el.querySelectorAll('[data-n25-save]').forEach(function (s) {
        var tpl = s.getAttribute('data-template') || '';
        if (tpl.indexOf('[amount]') > -1) s.textContent = tpl.replace('[amount]', fmtLocal(off).replace(/[.,]00(?!\d)/, ''));
      });
      el.querySelectorAll('[data-n25-sub]').forEach(function (s) {
        s.textContent = s.textContent.replace(/€\s?\d+(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?\s?€/, fmtLocal(Math.round(price / qty)));
      });
    });
  }

  /* ---------- Países con 1 reloj como máximo (el proveedor no deja comprar más) ---------- */
  var singleBusy = false;
  function enforceSingle() {
    var rule = window.n25SingleOnly;
    if (!rule || singleBusy) return;
    var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.item_count <= 1) return;
      var updates = {}, left = 1;
      cart.items.forEach(function (i) { var keep = Math.min(i.quantity, left); left -= keep; updates[i.key] = keep; });
      singleBusy = true;
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () {
          try { sessionStorage.setItem('n25-single-note', '1'); } catch (e) {}
          window.location.reload();
        })
        .finally(function () { singleBusy = false; });
    });
  }
  function showSingleNote() {
    var rule = window.n25SingleOnly;
    if (!rule) return;
    var shown = false;
    try { shown = sessionStorage.getItem('n25-single-note') === '1'; sessionStorage.removeItem('n25-single-note'); } catch (e) {}
    if (!shown || !rule.note) return;
    var bar = document.createElement('div');
    bar.className = 'n25-single-note';
    bar.setAttribute('role', 'status');
    bar.textContent = rule.note;
    document.body.appendChild(bar);
    setTimeout(function () { bar.classList.add('is-hidden'); }, 7000);
  }

  /* ---------- Utilidades de almacenamiento (pueden fallar en modo privado) ---------- */
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- Pop-up de bienvenida ---------- */
  function initPopup() {
    var pop = document.querySelector('[data-n25-popup]');
    if (!pop || pop.dataset.n25Ready) return;
    pop.dataset.n25Ready = '1';
    // Fuera de la sección, para que nada de la página quede por encima
    if (pop.getAttribute('data-design') !== 'true' && pop.parentElement !== document.body) document.body.appendChild(pop);
    var success = pop.querySelector('[data-n25-pop-success]');
    var days = parseInt(pop.getAttribute('data-days'), 10) || 14;
    function open() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('is-open'); }); }
    function close() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, 400);
      if (!success) store('n25-pop-closed', String(Date.now()));
    }
    pop.querySelectorAll('[data-n25-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    pop.querySelectorAll('[data-n25-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-n25-copy');
        var label = b.querySelector('small');
        var done = function () { if (label) label.textContent = label.getAttribute('data-copy-label'); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    });
    if (success) { store('n25-subscribed', '1'); open(); return; }
    if (pop.getAttribute('data-design') === 'true') {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(pop)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) close(); });
      return;
    }
    if (store('n25-subscribed')) return;
    var closedAt = parseInt(store('n25-pop-closed') || '0', 10);
    if (closedAt && Date.now() - closedAt < days * 864e5) return;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000;
    var shown = false;
    function show() { if (shown) return; shown = true; open(); }
    setTimeout(show, delay);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }

  /* ---------- Ventanas (guía de tallas) ---------- */
  function initDialogs(root) {
    (root || document).querySelectorAll('[data-n25-dialog-open]').forEach(function (btn) {
      if (btn.dataset.n25Ready) return;
      btn.dataset.n25Ready = '1';
      var dlg = document.getElementById(btn.getAttribute('data-n25-dialog-open'));
      if (!dlg || typeof dlg.showModal !== 'function') return;
      btn.addEventListener('click', function () { dlg.showModal(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-n25-dialog-close]')) dlg.close(); });
    });
  }

  /* ---------- Seguir pedido ---------- */
  function initTrack(root) {
    (root || document).querySelectorAll('[data-n25-track]').forEach(function (form) {
      if (form.dataset.n25Ready) return;
      form.dataset.n25Ready = '1';
      var input = form.querySelector('input');
      var box = form.parentElement.querySelector('[data-n25-track-result]');
      var widget = box ? box.querySelector('[data-n25-track-widget]') : null;
      var fallback = box ? box.querySelector('[data-n25-track-fallback]') : null;
      var lang = (document.documentElement.lang || 'en').slice(0, 2) === 'es' ? 'es' : 'en';
      function loadWidget(cb) {
        if (window.YQV5) return cb();
        var s = document.createElement('script');
        s.src = 'https://www.17track.net/externalcall.js';
        s.onload = cb;
        s.onerror = cb;
        document.head.appendChild(s);
      }
      function track(n) {
        var url = 'https://t.17track.net/' + lang + '#nums=' + encodeURIComponent(n);
        if (!box || !widget) { window.open(url, '_blank', 'noopener'); return; }
        box.hidden = false;
        if (fallback) fallback.href = url;
        widget.innerHTML = '';
        loadWidget(function () {
          if (!window.YQV5) { window.open(url, '_blank', 'noopener'); return; }
          window.YQV5.trackSingle({ YQ_ContainerId: widget.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: lang === 'es' ? 'es' : 'en', YQ_Num: n });
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = input.value.trim().replace(/\s+/g, '');
        if (n) track(n);
      });
      // Enlace del email de envío: /pages/track-order?tracking=NUMERO
      var q = new URLSearchParams(window.location.search).get('tracking');
      if (q) { input.value = q; track(q.trim().replace(/\s+/g, '')); }
    });
  }

  /* ---------- Barra de compra fija ---------- */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-n25-pdp]').forEach(function (pdp) {
      var bar = pdp.querySelector('[data-n25-sticky]');
      var main = pdp.querySelector('.n25-pdp__add');
      if (!bar || !main || bar.dataset.n25Ready) return;
      bar.dataset.n25Ready = '1';
      var label = bar.querySelector('[data-n25-sticky-label]');
      function refresh() {
        var offer = pdp.querySelector('[data-n25-offer].is-active');
        var txt = '';
        if (offer) {
          var t = offer.querySelector('.n25-offer__title strong');
          var p = offer.querySelector('.n25-offer__price span');
          txt = (t ? t.textContent : '') + (p ? ' · ' + p.textContent : '');
        } else {
          var price = pdp.querySelector('[data-n25-price]');
          txt = price ? price.textContent : '';
        }
        label.textContent = txt;
      }
      refresh();
      pdp.addEventListener('click', function () { setTimeout(refresh, 0); });
      bar.querySelector('[data-n25-sticky-buy]').addEventListener('click', function () { main.click(); });
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', below);
          bar.setAttribute('aria-hidden', below ? 'false' : 'true');
          bar.querySelector('[data-n25-sticky-buy]').tabIndex = below ? 0 : -1;
        });
      });
      io.observe(main);
    });
  }

  /* ---------- Comunidad: carrusel + vídeos que se reproducen al verse ---------- */
  function initCommunity(root) {
    (root || document).querySelectorAll('[data-n25-comm]').forEach(function (sec) {
      if (sec.dataset.n25Ready) return;
      sec.dataset.n25Ready = '1';
      var track = sec.querySelector('[data-n25-comm-track]');
      if (!track) return;
      function step(dir) {
        var card = track.querySelector('.n25-comm__card');
        var w = card ? card.getBoundingClientRect().width + 12 : 300;
        track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      }
      var prev = sec.querySelector('[data-n25-comm-prev]'), next = sec.querySelector('[data-n25-comm-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      var videos = sec.querySelectorAll('video');
      videos.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; });
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.4 });
      videos.forEach(function (v) { io.observe(v); });
    });
  }

  function initAll(root) {
    localizeBundles(root);
    initReveal(root);
    initCountUp(root);
    initStatements(root);
    initParallax(root);
    initProduct(root);
    initDialogs(root);
    initTrack(root);
    initSticky(root);
    initCommunity(root);
    updateStatements();
    updateParallax();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initPopup();
    window.addEventListener('scroll', onScroll, { passive: true });
    enforceGifts();
    showSingleNote();
    enforceSingle();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(enforceGifts, 300); setTimeout(enforceSingle, 300); });
    }
    window.addEventListener('resize', onScroll);
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initPopup(); });
})();
